import request from '@/utils/request'

// 获取未读提醒数量
export function getUnreadCount(params) {

  return new Promise((resolve, reject) => {
    request({
      url: '/notice.getUnreadCount',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve({
        data: res.data
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取提醒列表（可传参筛选已读/未读）
export function getNoticeList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/notice.getNoticeList',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve({
        data: res.data
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 标记单条提醒已读
export function markNoticeRead(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/notice.markNoticeRead',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 标记全部提醒已读
export function markAllNoticeRead(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/notice.markAllNoticeRead',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}